const BackArrow = (): JSX.Element => {
    return (
        <svg width="30" height="32" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="19" fill="white" fillOpacity="0.16" stroke="#9DBAE0" strokeWidth="2" />
            <path
                d="M19 14L13 19.9998L19 26"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M13 20H27" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default BackArrow;
